import { style } from '@vanilla-extract/css'

export const card = style({
  display: 'flex',
  flexFlow: 'column nowrap',
  alignItems: 'start',
  gap: '24px',
  borderRadius: '16px',
  padding: '16px',
  backgroundColor: 'white',
  boxShadow: '0px 8px 16px 0px #C5C5C50D',
  width: '100%',
})

// 画像と説明文のまとまり
export const flowerInfo = style({
  display: 'flex',
  flexFlow: 'column nowrap',
  alignItems: 'start',
  gap: '16px',
  width: '100%',
})

export const description = style({
  fontSize: '13px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  color: '#252525',
})

export const divider = style({
  width: '100%',
  height: '1px',
  backgroundColor: '#f2f1ef',
})
